<template>
  <div class="gmap-wrapper">
    <gmap-place-input
      class-name="ad1-location"
      :placeholder="$t('search.top.filters.location.text')"
      :default-place="location ? location.formatted_address : ''"
      @place_changed="onPlaceChanged"
    />
    <i
      class="empty el-icon-close pointer"
      @click="onPlaceChanged(null, true)"
    />
  </div>
</template>
<script>
  import { autoState } from '@fps/vue-toolkit/dist/util';
  import mutations from '@/store/filters/filters.mutationlist';
  import isEqual from 'lodash-es/isEqual';
  import { mapState } from 'vuex';

  export default {
    computed: {
      ...autoState(['location'], mutations.FILTER_SET, 0, 'filters'),
      ...mapState({
        locale: state => state.locale,
      }),
    },
    methods: {
      onPlaceChanged($event, overwrite = false) {
        // Make changes if he selects from the dropdown or he types in empty ( removes all text )
        if (($event && ($event.formatted_address || $event.name === '')) || overwrite) {
          if (!isEqual($event, this.location)) {
            const location = $event && $event.name === '' ? null : $event;

            this.location = location;
            this.$emit('place_changed', location);
          }
        } else {
          alert(this.$t('location.select-value.warn'));
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/MainLeftFilters/Location.vue